<script>
export default {
  props: {
    error: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div :class="$style.loading">
    <BaseIcon v-if="!error" name="spinner" spin />
    <p v-if="error">{{ errorMessage || `There was an error loading this page. Please, try again later.` }}</p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.loading {
  > div {
    display: flex;
    margin: auto;
  }

  text-align: center;
}
</style>
